import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/Home.vue'
// import SkillsPage from '../views/Skills.vue'
// import CompetencesPage from '../views/Competences.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  // {
  //   path: '/skills',
  //   name: 'SkillsPage',
  //   component: SkillsPage
  // }
  // {
  //   path: '/competences',
  //   name: 'Competences',
  //   component: CompetencesPage
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
